import FormHeader from "../../components/misc/FormHeader";
import { TableActions } from "../../components/tables/tableContext/TableContext";
import TableWidget from "../../components/tables/TableWidget";
import { getUnreceivedGoods } from "../../redux/api/receipt.api";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { crudRoutes, receptionRoutes } from "../../router/routesConstants";
import UnreceivedGoodsActionButtons from "./tableConfigs/UnreceivedGoodsActionButtons";
import {
  getUnreceivedGoodsTableData,
  unreceivedGoodsTableHeader,
} from "./tableConfigs/unreceivedGoodsTableConfig";

function UnreceivedGoods() {
  const dispatch = useAppDispatch();

  const {
    receipt: {
      unreceivedGoods: {
        data: unreceivedGoodsData,
        isLoading: isLoadingUnreceivedGoods,
      },
    },
  } = useAppSelector((state) => ({
    receipt: state.receipt,
  }));

  const handleTableActions = (action: TableActions) => {
    if (
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableSearch
    ) {
      dispatch(
        getUnreceivedGoods({
          page: action.tablePagination.page,
          perPage: action.tablePagination.rowsPerPage,
          dataDesc: action.tableSearch.dataDesc,
          furnizor: action.tableSearch.furnizor,
          factura: action.tableSearch.factura,
          dataFactura: action.tableSearch.dataFactura,
          nrAuto: action.tableSearch.nrAuto,
        }),
      );
    }
  };

  return (
    <div>
      <TableWidget
        CustomHeaderComponent={() => (
          <FormHeader
            title="Evidenta marfa nereceptionata"
            tooltipTitle="Adauga marfa nereceptionata"
            buttonRoute={`/${receptionRoutes.unreceivedGoods}/${crudRoutes.create}`}
            buttonIcon="ADD"
          />
        )}
        tableHeaderData={unreceivedGoodsTableHeader}
        tableItemsData={getUnreceivedGoodsTableData(unreceivedGoodsData.data)}
        tableLoading={isLoadingUnreceivedGoods}
        handleTableActions={handleTableActions}
        totalItems={unreceivedGoodsData.total}
        withGlobalSearch={false}
        ActionButtonsComponent={(props: any) => (
          <UnreceivedGoodsActionButtons {...props} />
        )}
      />
    </div>
  );
}

export default UnreceivedGoods;
